import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import ProgramService from "../../src/Services/Program.service";
const ProgramSelectOption = (props) => (_jsx("span", { className: "pl-2", children: _jsxs("span", { children: ["[", props.value.acronym, "] ", props.value.name] }) }));
const ProgramLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2345 - Argument of type '{ onChange: (programs: Program[]) => void; defaultIds: number[]; valueComponent: (props: { value: Program; }) => Element; optionRenderer: (program: Program) => Element; fetchItemsById: (ids: number[]) => Promise<...>; fetchOptions: (search: string) => Promise<...>; }' is not assignable to parameter of type 'LookupGenericProps<Program, number>'.
        valueComponent: ProgramSelectOption,
        optionRenderer: function optionRenderer(program) {
            return (_jsxs("span", { children: ["[", program.acronym, "] ", program.name] }));
        },
        fetchItemsById: (ids) => {
            return ProgramService.findAllById(ids);
        },
        fetchOptions: (search) => {
            return ProgramService.getPrograms({ query: search }).then(({ programs }) => programs);
        },
    });
};
export default ProgramLookup;
